import React, { useState, useEffect } from "react"
import { Navbar, Footer, ScrollToTop } from "./components"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import "./style.css"
import "./App.css"
import "bootstrap/dist/css/bootstrap.min.css"
import { LANGUAGES, ROUTES } from 'constants/general'
import getLanguage from "utils/getLanguage"

const App = () => {
    const [load, updateLoad] = useState(true)
    const [language, setLanguage] = useState(getLanguage())

    useEffect(() => {
        if (!localStorage.getItem('@rps/language')) {
            const lang = (navigator.language || navigator.userLanguage).split('-')[0].toLowerCase()
            onChangeLanguage(lang)
        }
        
        const timer = setTimeout(() => {
            updateLoad(false)
        }, 600)

        return () => clearTimeout(timer)
    }, [])

    const onChangeLanguage = val => {
        if (LANGUAGES.includes(val)) {
            setLanguage(val)
            localStorage.setItem('@rps/language', val)
        }
    }

    return (
        <Router>
            <div id={ load ? "preloader" : "preloader-none" }/>
            <ScrollToTop/>
            <div className="App" id={ load ? "no-scroll" : "scroll" }>
                <Navbar language={ language } onChangeLanguage={ onChangeLanguage }/>
                <Switch>
                    { ROUTES.map(route => <Route path={ route.to } exact component={ route.Page } key={ route.to }/>) }
                </Switch>
                <Footer/>
            </div>
        </Router>
    )
}

export default App